// extracted by mini-css-extract-plugin
export default {"Container":"Federal_Container__V8Vfi","section-1":"Federal_section-1__-4xMM","content":"Federal_content__GTj1s","section-2":"Federal_section-2__BfA0b"};